export const user_sipinfo = {
  domain: "skyangelcc.lambicall.com",
  websocket: "wss://skyangelcc.lambicall.com:9089/ws",
};
